import React from "react";
import { AssetType } from "../store/slices/mapsSlice";
import { Link } from "react-router-dom";
import MyIcon from "../Common/MyIcon";
import CogIcon from "../../assets/icons/cog.svg2";
import AssetIcon from "../../assets/icons/asset-01.svg2";
import LocationIcon from "../../assets/icons/mapping.svg2";
import AssetsIcon from "./AssetsIcon";
import AssetKind from "./AssetKind";

export default function AssetList({
  showTable = false,
  assets,
  actions,
}: {
  showTable?: boolean;
  assets: AssetType[];
  actions?: any;
}) {
  return (
    <>
      {showTable ? (
        <table className="table table-bg-transparent">
          <thead>
            <tr>
              {actions && <th></th>}
              <th>Label</th>
              <th>Type</th>
              <th>Has Location</th>
              <th>Locations</th>
              <th>Contacts</th>
              <th>Groups</th>
              <th>Dependant assets</th>
              <th>Connected assets</th>
            </tr>
          </thead>
          <tbody>
            {assets?.map((asset) => (
              <tr key={asset.Uuid}>
                {actions && <td>{actions(asset)}</td>}
                <td>
                  <Link to={`/assets/assets/${asset.Uuid}`}>{asset.Label}</Link>
                </td>
                <td>
                  <span>
                    <AssetsIcon assetKind={asset.Kind} />{" "}
                    <AssetKind assetKind={asset.Kind} />
                  </span>
                </td>
                <td>
                  {asset.HasLocation ? (
                    <span className="badge bg-success">YES</span>
                  ) : (
                    <span className="badge bg-secondary">NO</span>
                  )}
                </td>
                <td>
                  {asset.HasLocation ? asset.Stats?.Locations || 0 : "N/A"}
                </td>
                <td>{asset.Stats?.Contacts || 0}</td>
                <td>{asset.Stats?.Groups || 0}</td>
                <td>{asset.Stats?.Children || 0}</td>
                <td>{asset.Stats?.Parents || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="flex-grow-1">
          <div className="d-flex m-0 gap-2 flex-wrap">
            {assets.map((asset) => (
              <div
                key={asset.Uuid}
                className="card-light-gradient rounded-4 text-navy p-4 position-relative d-flex flex-column"
              >
                <div className="d-flex align-items-start">
                  <div>
                    <h3 className="fw-bold m-0">
                      {asset.Label || asset.Uuid?.slice(0, 5)}
                    </h3>
                    <div className=" text-secondary">
                      {asset.Reference ? `Ref: ${asset.Reference}` : <br />}
                    </div>
                    <div className=" text-secondary">
                      {asset.Description ? (
                        `Description: ${asset.Description}`
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className=" text-secondary">
                      {asset.Stats?.Parents && asset.ParentAssets?.[0] ? (
                        <>
                          Parent:
                          <AssetsIcon
                            assetKind={asset.ParentAssets?.[0].Kind}
                          />{" "}
                          {asset.ParentAssets?.[0].Label} $
                          {asset.Stats?.Parents > 1
                            ? `(+${asset.Stats?.Parents - 1} more)`
                            : ""}
                        </>
                      ) : (
                        <br />
                      )}
                    </div>
                  </div>
                  <div className="flex-grow-1"></div>{" "}
                  {actions && (
                    <div className="d-flex align-items-center">
                      {actions(asset)}
                    </div>
                  )}
                  <div className="p-1 bg-purple">
                    <Link to={`/assets/assets/${asset.Uuid}`}>
                      {" "}
                      <MyIcon Icon={CogIcon} width={20} className="rounded-3" />
                    </Link>
                  </div>
                </div>
                <hr className="text-secondary" />
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <AssetsIcon assetKind={asset.Kind} width={30} />
                    <span className="text-black fw-bold me-2">Type:</span>
                    <span className="text-black">
                      <AssetKind assetKind={asset.Kind} />
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <MyIcon
                      Icon={LocationIcon}
                      width={25}
                      className="rounded-3 me-2"
                    />
                    <span className="text-black fw-bold me-2">Location:</span>{" "}
                    {asset.HasLocation ? (
                      <span className="badge bg-success">
                        {asset.Stats?.Locations || 0}
                      </span>
                    ) : (
                      <span className="badge bg-secondary">NO</span>
                    )}
                  </div>
                </div>
                <div className="my-2 small text-secondary">
                  Last updated at:{asset.UpdatedAt}
                </div>
                <div className="flex-grow-1"></div>
                <div className="bg-white py-2 rounded-3 d-flex justify-content-evenly">
                  <div className=" text-center border-end px-3">
                    <h5 className="fw-bold text-navy m-0">
                      {asset.Stats?.Contacts || 0}
                    </h5>
                    <div
                      className="fw-bold text-black"
                      style={{ fontSize: "0.6rem" }}
                    >
                      CONTACTS
                    </div>
                  </div>
                  <div className="text-center border-end px-3">
                    <h5 className="fw-bold text-navy m-0">
                      {asset.Stats?.Groups || 0}
                    </h5>
                    <div
                      className="fw-bold text-black"
                      style={{ fontSize: "0.6rem" }}
                    >
                      GROUPS
                    </div>
                  </div>
                  <div className=" text-center border-end px-3">
                    <h5 className="fw-bold text-navy m-0">
                      {asset.Stats?.Children || 0}{" "}
                    </h5>
                    <div
                      className="fw-bold text-black"
                      style={{ fontSize: "0.6rem", lineHeight: "0.7rem" }}
                    >
                      DEPENDANT ASSETS{" "}
                    </div>
                  </div>
                  <div className=" text-center border-end px-3">
                    <h5 className="fw-bold text-navy m-0">
                      {asset.Stats?.Parents || 0}
                    </h5>
                    <div
                      className="fw-bold text-black "
                      style={{ fontSize: "0.6rem", lineHeight: "0.7rem" }}
                    >
                      CONNECTED ASSETS
                    </div>
                  </div>
                </div>{" "}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
